<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :labelCancel="labelCancel"
    labelBack="Atrás"
    :storeName="storeName"
    parentStoreName="Specialities"
    parentUrlKey="speciality_id"
    :submit="submit"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider ref="description" rules="required" v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  v-model="data.description"
                  label="Descripción"
                  prepend-inner-icon="fas fa-file"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="price_ars" rules="required" v-slot="{ errors }">
                <v-text-field
                    type="number"
                    :error-messages="errors"
                    v-model="data.price_ars"
                    label="Precio ARS"
                    prepend-inner-icon="fas fa-money"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="price_usd" rules="required" v-slot="{ errors }">
                <v-text-field
                    type="number"
                    :error-messages="errors"
                    v-model="data.price_usd"
                    label="Precio USD"
                    prepend-inner-icon="fas fa-money"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm},
    computed: {
      ...mapState({
      })
    },
    data() {
      return {
        storeName: 'Appointment_prices',
        title: "Precio de consulta",
        parentStoreName:'specialities',
        parentUrlKey:'speciality_id',
        data: {
          description: '',
          price_ars: '',
          price_usd: '',
          speciality_id: ''
        }
      }
    },
    created() {
      if (this.$route.params.speciality_id)
        this.data.speciality_id = this.$route.params.speciality_id;
    },
  }
</script>
